import axiosInstance from '@/utils/api.js'

var state = {
  telephonyService: []
}

var getters = {
  TELEPHONY_SERVICE: (state) => {
    return state.telephonyService
  }
}

var mutations = {
  SET_TELEPHONY_SERVICE: (state, payload) => {
    state.telephonyService = payload
  }
}

var actions = {
  GET_TELEPHONY_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/telephony?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_TELEPHONY_SERVICE', result.data)
    }
  },
  CREATE_TELEPHONY_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/telephony', payload)
  },
  UPDATE_TELEPHONY_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/telephony', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/telephonyServices.js